import { useQuery } from 'react-query';
import { useFirebase } from 'components/Firebase/index.js';
import { handleCall } from 'utils/index.js';

export const useShow = (showId) => {
  const firebase = useFirebase();

  return useQuery({
    queryKey: ['event', showId],
    // No id, no request: the query stays idle rather than resolving to null,
    // so a caller with an optional show pays nothing for the empty case.
    enabled: Boolean(showId),
    queryFn: async () => {
      if (!showId) return null;
      const agent = await firebase.getAgent();

      const { error, body } = await handleCall(agent, { url: `/events/${showId}` });

      if (error) {
        throw new Error(error);
      }
      return body;
    },
  });
};
